import { render, staticRenderFns } from "./BranchPOSettlement.vue?vue&type=template&id=6060fec6&"
import script from "./BranchPOSettlement.vue?vue&type=script&lang=js&"
export * from "./BranchPOSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports